import React, { FC } from 'react';

import { useSelector } from 'react-redux';
import {
  statusSelector,
  resultSelector,
  errorSelector,
  isRetryingSelector,
} from 'features/details/helpers';
import { stateSelector as chatStateSelector } from 'features/details/chat';
import { ErrorDisplay } from 'components/atoms';
import { WithAsync } from 'components/molecules';
import { useLocale } from 'lib';
import { HelpersList, visibleCallPeople } from './helpersList';
import styles from './style.module.scss';

/**
 * Helpers block.
 *
 * @version 1.0.0
 */
export const Helpers: FC = () => {

  const { t } = useLocale();

  const status = useSelector(statusSelector);
  const helpers = useSelector(resultSelector);
  const { participants, callEvents } = useSelector(chatStateSelector);
  const error = useSelector(errorSelector);
  const isRetrying = useSelector(isRetryingSelector);
  const people = visibleCallPeople(helpers, participants, callEvents, Date.now(), t('Helpers_Anonymous'));

  // Only need to render if there are any helpers
  return (
    <div className={styles.helpersBlock}>
      <div className={styles.blockTitleContainer}>
        {t('Helpers_WhoHelp')}
        {status.fulfilled && (
          <span className={styles.blockCount}>{people.length}</span>
        )}
      </div>
      <p className={styles.helperInfo}>{t('Helpers_CallInfo')}</p>
      <WithAsync
        status={status}
        error={() => (
          <ErrorDisplay
            isRetrying={isRetrying}
            {...error}
          />
        )}
      >
        {() => (
          <HelpersList
            helpers={helpers}
            participants={participants}
            callEvents={callEvents}
          />
        )}
      </WithAsync>
    </div>
  );

};
